import { TitleSection } from '@shared/components'
import { PropsWithChildren, ReactElement } from 'react'

interface BillingMainTemplateProps {
  title: string
  rightComponents?: ReactElement
}

export const BillingMainTemplate = ({
  children,
  title,
  rightComponents
}: PropsWithChildren<BillingMainTemplateProps>) => {
  return (
    <>
      <TitleSection title={title}>{rightComponents}</TitleSection>

      {children}
    </>
  )
}

// TODO: remove this component after fixing the invoice form on billing page
